import {AbstractUpload} from "./AbstractUpload";
import {Injectable} from "@angular/core";
import LocalDataSource from "../../../data-sources/LocalDataSource";
import {EnumSincronizacao} from "../../../domain/EnumSincronizacao";
import {Arquivo} from "../../../domain/Arquivo";
import {ArquivoHttpService} from "../../persist/http/ArquivoHttpService";
import {lastValueFrom} from "rxjs";
import {Directory, Filesystem} from "@capacitor/filesystem";

@Injectable()
export class UploadArquivo extends AbstractUpload<Arquivo>{
  constructor(private arquivoService: ArquivoHttpService) {
    super("Arquivo", arquivoService, Arquivo);
  }

  override async sendRecords(){
    const repo = LocalDataSource.getRepository(Arquivo)
    const pendencias = await  this.getPendencias()
    for (const a of pendencias) {
      try {
        const result = await Filesystem.readFile({path: a.nome, directory: Directory.Data})
        const base64Response = await fetch(`data:image/jpeg;base64,${result.data as string}`);
        const caminho = await lastValueFrom(this.arquivoService.send(a, await base64Response.blob()))
        a.situacao = EnumSincronizacao.ENVIADO
        a.caminho = caminho
        await repo.save(a)
        await this.sqlite.saveToStore()
      } catch (e) {
        console.error(e)
      }
    }
  }

  override async getPendencias(): Promise<Arquivo[]>{
    const repo = LocalDataSource.getRepository(Arquivo)
    return repo.find({
      where: {situacao: EnumSincronizacao.ENVIAR},
      relations: ['especime','projeto']
    })
  }
}
